import { cva } from 'class-variance-authority';

export const cvaCardContainer = cva([
  'payments-pro-cancelled-styles-cvaCardContainer',
  'bg-general_text_MII_dark',
  'rounded-[1rem]',
  'shadow-[0px_4px_40px_0px_rgba(0,0,0,0.24)]',
  'relative',
  'w-full',
  'max-w-[31.25rem]',
  'overflow-hidden',
]);

export const cvaInnerContainer = cva([
  'payments-pro-cancelled-styles-cvaInnerContainer',
  'box-border',
  'flex',
  'flex-col',
  'gap-6',
  'items-center',
  'justify-center',
  'px-8',
  'py-[5.625rem]',
  'relative',
  'w-full',
]);

export const cvaTitleContainer = cva([
  'ff-inter',
  'payments-pro-cancelled-styles-cvaTitleContainer',
  'flex',
  'flex-col',
  'gap-1',
  'items-center',
  'relative',
  'shrink-0',
  'text-center',
  'w-full',
  'z-[3]',
]);

export const cvaTitle = cva([
  'payments-pro-cancelled-styles-cvaTitle',
  'text-font_ds_title_title_title_32',
  'min-w-full',
  'relative',
  'shrink-0',
  'text-general_text_MII_default',
  'w-[min-content]',
]);

export const cvaSubtitle = cva([
  'payments-pro-cancelled-styles-cvaSubtitle',
  'text-font_ds_title_body_body_16',
  'relative',
  'shrink-0',
  'text-general_text_MII_disabled',
  'text-nowrap',
  'whitespace-pre',
]);

export const cvaFrameContainer = cva([
  'payments-pro-cancelled-styles-cvaFrameContainer',
  'flex',
  'flex-col',
  'gap-3',
  'items-center',
  'relative',
  'shrink-0',
  'z-[2]',
]);

export const cvaHelpText = cva([
  'ff-inter',
  'payments-pro-cancelled-styles-cvaHelpText',
  'text-font_ds_title_body_body_14',
  'relative',
  'shrink-0',
  'text-general_text_MII_secondary_ii',
  'text-center',
  'max-w-[11.25rem]',
]);

export const cvaContactButton = cva([
  'ff-inter',
  'payments-pro-cancelled-styles-cvaContactButton',
  'px-8',
]);

export const cvaGradientBottom = cva([
  'payments-pro-cancelled-styles-cvaGradientBottom',
  'absolute',
  'bottom-[-132px]',
  'h-[184px]',
  'left-[calc(50%+0.5px)]',
  'translate-x-[-50%]',
  'w-[29.5rem]',
  'z-[1]',
  'pointer-events-none',
]);
